<div class="row">
    <div class="col-3">
        <div class="nav-sidebar">
            <small class="text-muted">Bruger: <span *ngIf="this.authService.currentUser">{{this.authService.currentUser.name}}</span></small>

            <h2 class="mt-3  mb-0" style="color: #0B3793;">Menu</h2>

            <hr class="mt-0">

            <ul class="list-unstyled">
                <li><a routerLink="/orders/add">Ny ordre</a></li>
                <li>...</li>
            </ul>

            <ul class="list-unstyled">
                <li>...</li>
            </ul>

            <ul class="list-unstyled">
                <li>...</li>
            </ul>

            <ul class="list-unstyled">
                <li>...</li>
            </ul>
        </div>
    </div>

    <div class="col">
        <app-ten-four-orders [activeClient]="'creditor'"></app-ten-four-orders>
    </div>
</div>
